(() => {
  if (customElements.get('luminant-mobile-layout')) return;
  class MobileLayout extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.hero = this.closest('luminant-watch-hero');
      if (!this.hero) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.mobile = matchMedia('(max-width: 749px)');
      this.right = false;
      this.busyUntil = 0;
      this.heroVisible = true;
      const updateHeader = () => {
        document.body.classList.toggle('luminant-mobile-below-hero', this.mobile.matches && !this.heroVisible);
      };
      this.mobile.addEventListener('change', updateHeader, options);
      this.headerObserver = new IntersectionObserver(([entry]) => {
        this.heroVisible = entry.isIntersecting;
        updateHeader();
      }, { rootMargin: '-64px 0px 0px 0px' });
      this.headerObserver.observe(this.hero);
      const turn = () => {
        if (this.hero.dataset.state !== 'ready' || performance.now() < this.busyUntil) return;
        this.busyUntil = performance.now() + 3200;
        this.right = !this.right;
        this.hero.dataset.mobilePose = this.right ? 'right' : 'left';
      };
      this.hero.querySelector('.luminant-hero__viewer').addEventListener('click', turn, options);
      this.hero.querySelector('.luminant-hero__spin').addEventListener('click', turn, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.busyUntil = 0;
      }, options);
      this.stateObserver = new MutationObserver(() => {
        if (this.hero.dataset.state !== 'ready') {
          this.right = false;
          this.busyUntil = 0;
          delete this.hero.dataset.mobilePose;
        }
      });
      this.stateObserver.observe(this.hero, { attributes: true, attributeFilter: ['data-state'] });
      const collection = document.querySelector('#MainContent [id^="collection-"]');
      const link = this.hero.querySelector('.luminant-hero__mobile-link');
      if (collection && link) {
        link.href = `#${collection.id}`;
        link.addEventListener('click', event => {
          if (!this.mobile.matches || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          collection.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options);
      }
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null;
      this.headerObserver?.disconnect();
      this.stateObserver?.disconnect();
      document.body.classList.remove('luminant-mobile-below-hero');
    }
  }
  customElements.define('luminant-mobile-layout', MobileLayout);
})();
